import React from 'react';
import { useApp } from '../context/AppContext';
import { DoorDetail } from './DoorDetail';
import { FloorDetail } from './FloorDetail';
import { BuildingDetail } from './BuildingDetail';
import { ScrollArea } from './ui/scroll-area';
import { DoorOpen, Layers, Building2 } from 'lucide-react';

export function DetailPanel() {
  const { state } = useApp();
  const { selectedNode, currentQuote } = state;

  if (!selectedNode) {
    return (
      <div className="h-full flex items-center justify-center bg-muted/30" data-testid="detail-panel-empty">
        <div className="text-center">
          <div className="w-12 h-12 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <DoorOpen className="w-6 h-6 text-muted-foreground" />
          </div>
          <p className="text-muted-foreground text-sm">
            Select a building, floor, or door from the tree to view details
          </p>
        </div>
      </div>
    );
  }

  // Find the selected item
  const { type, path } = selectedNode;
  let content = null;
  let title = '';
  let icon = null;

  if (type === 'building') {
    const building = currentQuote.buildings.find(b => b.id === path.buildingId);
    if (building) {
      content = <BuildingDetail building={building} />;
      title = building.name;
      icon = <Building2 className="w-5 h-5 text-primary" />;
    }
  } else if (type === 'floor') {
    const building = currentQuote.buildings.find(b => b.id === path.buildingId);
    const floor = building?.floors.find(f => f.id === path.floorId);
    if (floor) {
      content = <FloorDetail floor={floor} building={building} />;
      title = `${building.name} / ${floor.name}`;
      icon = <Layers className="w-5 h-5 text-amber-600" />;
    }
  } else if (type === 'door') {
    const building = currentQuote.buildings.find(b => b.id === path.buildingId);
    const floor = building?.floors.find(f => f.id === path.floorId);
    const door = floor?.doors.find(d => d.id === path.doorId);
    if (door) {
      content = <DoorDetail door={door} floor={floor} building={building} />;
      title = `${floor.name} / ${door.name}`;
      icon = <DoorOpen className="w-5 h-5 text-slate-500" />;
    }
  }

  return (
    <div className="h-full flex flex-col bg-white" data-testid="detail-panel">
      {/* Panel Header */}
      <div className="h-14 border-b border-border flex items-center px-4 gap-3 shrink-0">
        {icon}
        <h2 className="font-medium text-base truncate">{title}</h2>
      </div>

      {/* Panel Content */}
      <ScrollArea className="flex-1">
        <div className="p-4">
          {content}
        </div>
      </ScrollArea>
    </div>
  );
}
